import { Icon, Intent, Tag } from "@blueprintjs/core";

import { Tooltip } from "@/components/helpers/ui/blueprint-overrides/Tooltip";
import { Box, Flex } from "@/components/layout/flexbox";
import { Avatar } from "@/components/pieces/users/Avatar";
import { SUBTEXT_COLOR } from "@/css/constants";
import { AttendingStatus, InvitationStatus } from "@/graphql";
import { Attendee } from "@/types/meetings";

import { AttendingStatusIcon } from "./AttendingStatusIcon";

const AttendeeInvitationStatus: Partial<
  Record<InvitationStatus | "Organizer", { text: string; intent: Intent }>
> = {
  [InvitationStatus.Inviting]: {
    text: "Inviting",
    intent: Intent.PRIMARY,
  },
  [InvitationStatus.Failed]: {
    text: "Invite Failed",
    intent: Intent.DANGER,
  },
  [InvitationStatus.Init]: {
    text: "Invite Pending",
    intent: Intent.NONE,
  },
  Organizer: {
    text: "Organizer",
    intent: Intent.PRIMARY,
  },
};

interface AttendeeRowViewProps {
  attendee: Attendee;
  isOrganizer: boolean;
  mode: "view" | "view-with-status" | "edit";
  onClick?: (attendee: Attendee) => void;
}

export function AttendeeRowView({
  attendee,
  isOrganizer,
  mode = "view",
  onClick,
}: AttendeeRowViewProps) {
  const statusKey =
    isOrganizer || !attendee.status ? "Organizer" : attendee.status;
  const status = AttendeeInvitationStatus[statusKey];

  const attendingStatusKey = isOrganizer
    ? AttendingStatus.Attending
    : attendee.attendingStatus;
  return (
    <Flex py={2} alignItems="center">
      <Tooltip content={attendee?.user?.email || attendee?.email}>
        {attendee?.user?.id && <Avatar size={24} user={attendee?.user} />}
      </Tooltip>
      <Box ml="5px">
        {" "}
        {attendee?.user?.name || attendee?.user?.email || attendee?.email}
        {!isOrganizer && attendee?.status === InvitationStatus.Invited ? (
          <>
            {"  "}
            <AttendingStatusIcon attendingStatus={attendingStatusKey} />
          </>
        ) : null}
      </Box>
      {mode === "view-with-status" ? (
        <Box flex={1} textAlign={"right"} fontSize={14} color={SUBTEXT_COLOR}>
          {status?.text}
        </Box>
      ) : null}
      {mode === "edit" ? (
        <Flex
          flex={1}
          textAlign={"right"}
          fontSize={14}
          color={SUBTEXT_COLOR}
          justifyContent="flex-end"
        >
          {status && status.text === "Invite Failed" && (
            <Tag round intent={status?.intent}>
              {status?.text}
            </Tag>
          )}
          {isOrganizer ? (
            "Organizer"
          ) : (
            <Box
              css={{ cursor: "pointer" }}
              onClick={() => {
                onClick && onClick(attendee);
              }}
            >
              {" "}
              <Icon icon="cross" />
            </Box>
          )}
        </Flex>
      ) : null}
    </Flex>
  );
}
